export default __webpack_public_path__ + "static/media/video.37fe3e62.svg";